import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Location",
  "use": "svg-icon-Location-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Location\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 1.8c3.419 0 6.2 2.781 6.2 6.2s-2.781 6.2-6.2 6.2A6.207 6.207 0 0 1 1.8 8c0-3.419 2.781-6.2 6.2-6.2zM3.56 7.847L11 5l-2.659 7.629L7 9 3.56 7.847z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol